let currentPage = 0;

function setSearchParam(value, isLanguageButton = false, languageCode = '') {
  let params = new URLSearchParams(window.location.search);
  params.set('page', value);

  let newPath = window.location.pathname;
  const pathSegments = newPath.split('/').filter(Boolean);

  if (isLanguageButton && languageCode) {
    if (pathSegments[0] && /^[a-z]{2}-[a-z]{2}$/i.test(pathSegments[0])) {
      pathSegments[0] = languageCode;
    } else {
      pathSegments.unshift(languageCode);
    }

    newPath = '/' + pathSegments.join('/');
  }

  const htmlElement = document.querySelector('html');
  const newUrl = newPath + '?' + params.toString();

  if (languageCode.split('-')[0] != htmlElement.getAttribute('lang') && isLanguageButton) {
    htmlElement.setAttribute('lang', languageCode.split('-')[0] || 'fr');
    history.replaceState(null, '', newUrl);
    window.location.reload();
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    history.replaceState(null, '', newUrl);
  }
}

async function sendFormDataToKlaviyo() {
  const checkboxGroupOrder =
    document.querySelector('.a4-kakemono-section-form-request-checkbox[name="form-request-checkbox-group-order"]')?.checked || false;
  const checkboxClinicalStudy =
    document.querySelector('.a4-kakemono-section-form-request-checkbox[name="form-request-checkbox-clinical-study"]')?.checked || false;
  const checkboxClinicalResults =
    document.querySelector('.a4-kakemono-section-form-request-checkbox[name="form-request-checkbox-clinical-results"]')?.checked || false;
  const checkboxOther =
    document.querySelector('.a4-kakemono-section-form-request-checkbox[name="form-request-checkbox-other"]')?.checked || false;
  const otherText = document.querySelector('textarea[name="other-text"]')?.value || '';
  const whereMeet = document.querySelector('input[name="popup-input-meet"]')?.value || '';

  const firstName = document.querySelector('input[name="first_name"]')?.value || '';
  const lastName = document.querySelector('input[name="last_name"]')?.value || '';
  const email = document.querySelector('input[name="Email"]')?.value || '';
  const profession = document.querySelector('.page-form-requisites input[type="hidden"]')?.value || '';
  const message = document.querySelector('textarea[name="message-input"]')?.value || '';
  let language = window.KL_LANGUAGE === 'fr' ? 'FR' : 'EN';

  klaviyo
    .identify({
      $email: email,
      $first_name: firstName,
      $last_name: lastName,
      checkboxGroupOrder,
      checkboxClinicalStudy,
      checkboxClinicalResults,
      checkboxOther,
      otherText,
      whereMeet,
      profession,
      message,
      Language: language,
    })
    .then(() => {
      klaviyo.track('A4 kakemono', {
        checkboxGroupOrder,
        checkboxClinicalStudy,
        checkboxClinicalResults,
        checkboxOther,
        otherText,
        whereMeet,
        profession,
        Source: 'kakemono_form',
        Language: language,
        message,
      });
    });

  // Base options for API calls
  const requestOptions = (body) => ({
    method: 'POST',
    headers: {
      accept: 'application/vnd.api+json',
      revision: '2025-10-15',
      'content-type': 'application/vnd.api+json',
    },
    body: JSON.stringify(body),
  });

  const API_URL = 'https://a.klaviyo.com/client/subscriptions?company_id=UQzMTp';

  // Email subscription
  if (email) {
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: { newKey: 'New Value' },
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: 'SB4yQQ' } },
        },
      },
    };

    try {
      await fetch(API_URL, requestOptions(body));
    } catch (e) {
      console.warn('Klaviyo email subscription error:', e);
    }
  }
}

async function showNextPage(nextPage, previousPage, isLanguageButton = false, languageButton) {
  setSearchParam(nextPage, isLanguageButton, languageButton);
  document.querySelector(`.page-${nextPage}`).style.display = 'flex';
  if (previousPage) {
    document.querySelector(`.page-${previousPage}`).style.display = 'none';
  }

  if (previousPage === 'language' && nextPage === 'form-request') {
    const headerButtons = document.querySelector('.header-a4-kakemono-nav');
    headerButtons.style.display = 'flex';
  } else if (previousPage === 'form-request' && nextPage === 'form-requisites') {
    const headerPrev = document.querySelector('#header-a4-kakemono-nav-request');
    const headerNext = document.querySelector('#header-a4-kakemono-nav-requisites');
    headerPrev.classList.remove('active');
    headerPrev.classList.add('completed');
    headerNext.classList.add('active');
  } else if (previousPage === 'form-requisites' && nextPage === 'form-request') {
    const headerNext = document.querySelector('#header-a4-kakemono-nav-request');
    const headerPrev = document.querySelector('#header-a4-kakemono-nav-requisites');
    headerNext.classList.add('active');
    headerNext.classList.remove('completed');
    headerPrev.classList.remove('active');
    currentPage--;
  } else if (previousPage === 'form-requisites' && nextPage === 'final') {
    const headerButtons = document.querySelector('.header-a4-kakemono-nav');
    headerButtons.style.display = 'none';
    await sendFormDataToKlaviyo();
  }
}

function initPages(pagesURL) {
  const params = new URLSearchParams(window.location.search);
  const page = params.get('page');

  if (page) {
    const pageIndex = pagesURL.indexOf(page);
    if (pageIndex !== -1) {
      document.querySelector(`.page-${pagesURL[pageIndex]}`).style.display = 'flex';
      document.querySelector(`.page-language`).style.display = 'none';
    }
  }

  if (page === 'form-request' || page === 'form-requisites') {
    const headerNav = document.querySelector('.header-a4-kakemono-nav');
    if (headerNav) {
      headerNav.style.display = 'flex';
    }
  }

  if (page === 'form-requisites') {
    const headerPrev = document.querySelector('#header-a4-kakemono-nav-request');
    const headerNext = document.querySelector('#header-a4-kakemono-nav-requisites');
    if (headerPrev && headerNext) {
      headerPrev.classList.add('completed');
      headerPrev.classList.remove('active');
      headerNext.classList.add('active');
    }
  }
}

function initCheckboxes() {
  document.querySelectorAll('.a4-kakemono-section-form-request-checkbox-container').forEach((container) => {
    // Пропускаем контейнер для other
    if (container.classList.contains('other')) return;

    const checkbox = container.querySelector('.a4-kakemono-section-form-request-checkbox');
    const label = container.querySelector('.a4-kakemono-section-form-request-checkbox-label');

    // Клик по контейнеру, кроме самого чекбокса
    container.addEventListener('click', (e) => {
      if (e.target === checkbox) return;
      checkbox.checked = !checkbox.checked;
      label.classList.toggle('active', checkbox.checked);
    });

    // Клик или изменение чекбокса напрямую
    checkbox.addEventListener('change', () => {
      label.classList.toggle('active', checkbox.checked);
    });

    // Инициализация состояния при загрузке
    label.classList.toggle('active', checkbox.checked);
  });
}
function initOtherContainer() {
  const otherCheckbox = document.querySelector('#form-request-checkbox-other');
  const otherCheckboxContainer = document.querySelector('.a4-kakemono-section-form-request-checkbox-container.other');
  const otherLabel = otherCheckboxContainer.querySelector('.a4-kakemono-section-form-request-checkbox-label');
  const otherContainer = document.querySelector('#other-text-container');
  const otherInput = otherContainer.querySelector('textarea, input');

  const toggleOtherContainer = (checked) => {
    // Добавляем/удаляем класс active для контейнера и лейбла
    otherCheckboxContainer.classList.toggle('active', checked);
    otherLabel.classList.toggle('active', checked);

    if (checked) {
      otherContainer.classList.add('active');
    } else {
      otherContainer.classList.remove('active');
    }

    if (checked && otherInput) {
      otherContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      otherInput.focus();
      otherInput.focus();
      const length = otherInput.value.length;
      otherInput.setSelectionRange(length, length);
    }
  };

  otherCheckboxContainer.addEventListener('click', (e) => {
    if (e.target === otherCheckbox) return;
    otherCheckbox.checked = !otherCheckbox.checked;
    toggleOtherContainer(otherCheckbox.checked);
  });

  otherCheckbox.addEventListener('change', () => {
    toggleOtherContainer(otherCheckbox.checked);
  });

  // Инициализация состояния при загрузке
  toggleOtherContainer(otherCheckbox.checked);

  initOtherTextCounter();
}

function initOtherTextCounter() {
  const textarea = document.getElementById('other-text-input');
  const counter = document.getElementById('other-text-counter');
  const maxLength = textarea.getAttribute('maxlength');

  textarea.addEventListener('input', () => {
    const remaining = maxLength - textarea.value.length;
    counter.textContent = counter.textContent.replace(/\d+/, remaining);
  });
}

function togglePopup(popup) {
  popup.classList.toggle('active');
}

function closePopup(popup) {
  popup.classList.remove('active');
}

function setSelectedOption(option, meetButton, meetInput, popup, popupOptions) {
  popupOptions.forEach((o) => o.classList.remove('active'));
  option.classList.add('active');

  const selectedText = option.querySelector('p').textContent;

  meetButton.querySelector('p').textContent = selectedText;
  meetInput.value = selectedText;
  meetButton.classList.add('selected');

  closePopup(popup);
}

function initOutsideClickHandler(meetContainers) {
  meetContainers.forEach((container) => {
    container.addEventListener('click', (e) => {
      e.stopPropagation();
      closePopup(container);
    });
  });
}

function initAgreeCheckbox() {
  const agreeCheckbox = document.querySelector('#contacted-agree');
  const agreeLabel = document.querySelector('#contacted-agree-label');

  agreeLabel.addEventListener('click', (e) => {
    agreeCheckbox.checked = !agreeCheckbox.checked;
    agreeCheckbox.dispatchEvent(new Event('change'));
  });
}

function initPopupSelections() {
  const meetContainers = document.querySelectorAll('.a4-kakemono-section-form-meet-button');

  meetContainers.forEach((button) => {
    const formSection = button.closest('.a4-kakemono-section-form-wrp');
    const popup = formSection.querySelector('.a4-kakemono-selection-popup');
    const popupOptions = popup.querySelectorAll('.a4-kakemono-selection-popup-option');

    const meetInput = formSection.querySelector('input[type="hidden"]');
    const meetContainer = button.parentElement;

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopup(popup);
    });

    popupOptions.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        setSelectedOption(option, button, meetInput, popup, popupOptions);
      });
    });

    document.addEventListener('click', (e) => {
      const isInside = meetContainer.contains(e.target) || popup.contains(e.target);
      if (!isInside) closePopup(popup);
    });
  });
}

function initNextButtonActivation() {
  const checkboxes = document.querySelectorAll('.a4-kakemono-section-form-request-checkbox');
  const textareas = document.querySelectorAll('textarea');
  const inputs = document.querySelectorAll('.a4-kakemono-section-form-requisites-input');
  const nextButtons = document.querySelectorAll('.a4-kakemono-section-form-next-page');

  function updateButtonState() {
    const isAnyChecked = Array.from(checkboxes).some((cb) => cb.checked);
    const isAnyTextEntered =
      Array.from(textareas).some((ta) => ta.value.trim().length > 0) || Array.from(inputs).some((input) => input.value.trim().length > 0);

    const isActive = isAnyChecked || isAnyTextEntered;
    nextButtons.forEach((btn) => {
      if (!btn.classList.contains('resquisites')) {
        btn.classList.toggle('active', isActive);
        btn.disabled = !isActive;
      }
    });
  }

  checkboxes.forEach((cb) => cb.addEventListener('change', updateButtonState));
  document.querySelectorAll('.a4-kakemono-section-form-request-checkbox-container').forEach((container) => {
    container.addEventListener('click', updateButtonState);
  });

  textareas.forEach((ta) => ta.addEventListener('input', updateButtonState));
  inputs.forEach((input) => input.addEventListener('input', updateButtonState));

  updateButtonState();
}

function initRequisitesValidation() {
  const requisitesSection = document.querySelector('.page-form-requisites');
  const firstNameInput = requisitesSection.querySelector('input[name="first_name"]');
  const lastNameInput = requisitesSection.querySelector('input[name="last_name"]');
  const emailInput = requisitesSection.querySelector('input[name="Email"]');
  const professionInput = requisitesSection.querySelector('input[type="hidden"]');
  const agreeCheckbox = requisitesSection.querySelector('input[name="contacted-agree"]');
  const nextButton = requisitesSection.querySelector('.a4-kakemono-section-form-next-page');
  const errorPopup = requisitesSection.querySelector('.a4-kakemono-error-popup');
  const emptyText = errorPopup.querySelector('.a4-kakemono-error-popup-content-text.empty');
  const unvalidText = errorPopup.querySelector('.a4-kakemono-error-popup-content-text.unvalid');

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setErrorState(input, isError) {
    if (isError) input.classList.add('error');
    else input.classList.remove('error');
  }

  function getInvalidFields() {
    const emptyFields = [];
    const invalidFields = [];

    if (!firstNameInput.value.trim()) emptyFields.push('First Name');
    if (!lastNameInput.value.trim()) emptyFields.push('Last Name');
    if (!emailInput.value.trim()) emptyFields.push('Email');
    if (!professionInput.value.trim()) emptyFields.push('Profession');
    if (!agreeCheckbox.checked) emptyFields.push('Agreement');

    if (emailInput.value.trim() && !validateEmail(emailInput.value.trim())) {
      invalidFields.push('Email');
    }

    return { emptyFields, invalidFields };
  }

  function markErrors({ emptyFields, invalidFields }) {
    setErrorState(firstNameInput, emptyFields.includes('First Name') || invalidFields.includes('First Name'));
    setErrorState(lastNameInput, emptyFields.includes('Last Name') || invalidFields.includes('Last Name'));
    setErrorState(emailInput, emptyFields.includes('Email') || invalidFields.includes('Email'));

    const professionButton = document.querySelector('.a4-kakemono-section-form-meet-button.requisites');
    setErrorState(professionButton, emptyFields.includes('Profession') || invalidFields.includes('Profession'));

    const agreeLabel = document.querySelector('#contacted-agree-label');
    setErrorState(agreeCheckbox, emptyFields.includes('Agreement'));
    setErrorState(agreeLabel, emptyFields.includes('Agreement'));
  }

  function showErrorPopup(emptyFields, invalidFields) {
    emptyText.style.display = 'none';
    unvalidText.style.display = 'none';

    if (emptyFields.length > 0) {
      emptyText.textContent = emptyText.textContent.replace('""', `"${emptyFields.join(', ')}"`);
      emptyText.style.display = 'block';
    }

    if (invalidFields.length > 0) {
      unvalidText.textContent = unvalidText.textContent.replace('""', `"${invalidFields.join(', ')}"`);
      unvalidText.style.display = 'block';
    }

    if (emptyFields.length > 0 || invalidFields.length > 0) {
      errorPopup.classList.add('active');
      setTimeout(() => {
        errorPopup.classList.remove('active');
        emptyText.style.display = 'none';
        unvalidText.style.display = 'none';
        emptyText.textContent = 'Field "" is required';
        unvalidText.textContent = 'Field "" is invalid';
      }, 4000);
    }
  }

  function isFormValid() {
    const { emptyFields, invalidFields } = getInvalidFields();
    return emptyFields.length === 0 && invalidFields.length === 0;
  }

  function isFormPartiallyFilled() {
    return (
      firstNameInput.value.trim().length > 0 ||
      lastNameInput.value.trim().length > 0 ||
      emailInput.value.trim().length > 0 ||
      professionInput.value.trim().length > 0 ||
      agreeCheckbox.checked
    );
  }

  function updateButtonState() {
    const anyFilled = isFormPartiallyFilled();
    const allValid = isFormValid();

    if (anyFilled) {
      nextButton.classList.add('invalid');
      nextButton.classList.remove('active');
      nextButton.disabled = false;
    } else {
      nextButton.classList.remove('invalid');
      nextButton.classList.remove('active');
      nextButton.disabled = true;
    }

    if (allValid) {
      nextButton.classList.remove('invalid');
      nextButton.classList.add('active');
      nextButton.disabled = false;
    }
  }

  [firstNameInput, lastNameInput, emailInput].forEach((input) => {
    if (input) input.addEventListener('input', updateButtonState);
  });

  const professionPopupOptions = requisitesSection.querySelectorAll('.a4-kakemono-selection-popup-option');
  professionPopupOptions.forEach((option) => {
    option.addEventListener('click', updateButtonState);
  });

  agreeCheckbox.addEventListener('change', updateButtonState);

  nextButton.addEventListener('click', (e) => {
    const { emptyFields, invalidFields } = getInvalidFields();

    markErrors({ emptyFields, invalidFields });

    if (emptyFields.length === 0 && invalidFields.length === 0) {
      nextButton.classList.remove('invalid');
    } else {
      nextButton.classList.add('invalid');
      showErrorPopup(emptyFields, invalidFields);
    }
  });

  updateButtonState();
}

document.addEventListener('DOMContentLoaded', function initA4Kakemono() {
  const pagesURL = ['language', 'form-request', 'form-requisites', 'final'];
  const meetContainers = document.querySelectorAll('.a4-kakemono-selection-popup');

  initPages(pagesURL);
  initCheckboxes();
  initOtherContainer();
  initAgreeCheckbox();
  initPopupSelections();
  initNextButtonActivation();
  initRequisitesValidation();
  initOutsideClickHandler(meetContainers);

  document.querySelectorAll('.next-a4-page').forEach((button) => {
    button.addEventListener('click', async () => {
      if (!button.classList.contains('invalid')) {
        currentPage++;
        const isbuttonLanguage = button.id === 'a4-kakemono-lang-fr' || button.id === 'a4-kakemono-lang-en';
        let languageButton = '';
        if (isbuttonLanguage) {
          languageButton = button.id === 'a4-kakemono-lang-fr' ? 'fr-fr' : 'en-gb';
        }

        await showNextPage(pagesURL[currentPage], pagesURL[currentPage - 1], isbuttonLanguage, languageButton);
      }
    });
  });
});
